module.exports = __webpack_public_path__ + "static/media/offer-6.4767989b.png";